import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { rx, Subject, Subscription } from '@shared/rx';
import { get, has } from 'lodash';

/**
 * @example
 *
 *    <button (appThrottleClick)="onClick($event)">...</button>
 *
 */
@Directive({
  selector: '[appThrottleClick]',
})
export class ThrottleClickDirective implements OnInit, OnDestroy {
  @Input()
  public throttleTimeMs: number = 1000;

  @Output()
  public appThrottleClick: EventEmitter<MouseEvent> = new EventEmitter();

  private clicks: Subject<MouseEvent> = new Subject();
  private subscription?: Subscription;

  public ngOnInit(): void {
    this.subscription = this.clicks
      .pipe(
        rx.throttleTime(this.throttleTimeMs),
        rx.debounceTime(0),
        rx.distinctUntilChanged(),
      )
      .subscribe((e) => this.appThrottleClick.emit(e));
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  public clickEvent(event: PointerEvent): void {
    if (!has(event, 'pointerType') || get(event, 'pointerType') !== '') {
      event.preventDefault();
      event.stopPropagation();
      this.clicks.next(event);
    }
  }
}
